import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import "../css/Home.css";
import "../css/frontpage.css";

const PANES = [
  { id: "", src:"4.png", title_en: "The Wind's Combing", note_en: "", title_fa: "", note_fa: "شانه‌ی باد"},
  { id: "", src:"12.png", title_en: "The Stillness Between", note_en: "", title_fa: "", note_fa: "سکوتِ میان دو لحظه" },
  { id: "", src:"14.png", title_en: "The First Ring", note_en: "", title_fa: "", note_fa: "نخستین حلقه" },
  { id: "", src:"6.png", title_en: "Rivers of Bark, Sky of Ember", note_en: "", title_fa: "رودهای شاخه، آسمانِ آتش", note_fa: "" },
];

export default function SectionSix({setlang}) {
    const [scrollY, setScrollY] = useState(0);
    const heroRef = useRef(null);
  
    useEffect(() => {
      const onScroll = () => setScrollY(window.scrollY);
      window.addEventListener("scroll", onScroll, { passive: true });
      return () => window.removeEventListener("scroll", onScroll);
    }, []);
  
    // Parallax amounts derived from scroll position
    const glowShift = scrollY * 0.15;
    const paneShift = scrollY * 0.04;

  return (
    <div className="av-page">

    <div className="creative-page">
      <div className="av-glow-field" aria-hidden="true">
        <div
          className="av-glow av-glow--amber"
          style={{ transform: `translate3d(0, ${glowShift}px, 0)` }}
          />
        <div
          className="av-glow av-glow--teal"
          style={{ transform: `translate3d(0, ${-glowShift * 0.6}px, 0)` }}
          />
        <div className="av-grain" />
      </div>
      
      {/* SECTION 2 - Interactive Glass Cards */}
      <section className="av-hero" ref={heroRef}>
        <div className="av-hero-pane">
          <p className="av-eyebrow">Auctions &amp; Bids — Iran</p>
          <h1 className="av-headline">
           {setlang==="en"?"Auction Way of Selling":"مزایده‌های هوشمند"} 
            <br />
             
          </h1>
          {setlang === "en"? 
          <>
          <p className="av-subtext"> Join a growing community marketplace built for fairness, simplicity, and trust—where anyone can buy, sell, and trade effortlessly anytime, anywhere nationwide. Place your masterpiece for demonstration or sell your products through bidding and find the fairest deals</p>
          <p className="av-subtext">Explore, scroll and enjoy the journey through unique creations!</p>
          </>
          :
          <>
          <p className="av-subtext"> به یک بازار اجتماعی در حال رشد بپیوند که بر پایه سرعت، سادگی و اعتماد ساخته شده، جایی که هر کسی می‌تونه در هر زمان و هر مکان، آسان خرید، فروش و معامله کنه</p>
          <p className="av-subtext">و آن هم نمایش و فروش از راه مزایده</p>
          </>
          }
          <br />
          <div className="av-cta-row">
            <Link to={`/${setlang}/gallery`} >
              <button className="av-btn av-btn--solid">{setlang==="en"?"See the Gallery":"نمایش گالری"}</button>
            </Link>
            <Link to={`/${setlang}/community`}>
              <button className="av-btn av-btn--ghost">{setlang==="en"?"join the Community":"به ما بپیوند"}</button>
            </Link>
          </div>
        </div>

        
        <div
          className="av-hero-image-frame"
          style={{ transform: `translate3d(0, ${-paneShift * 2}px, 0)` }}
        >
          <div className="av-hero-image-frame">
            <img className="av-hero-image" src="aigen.png" alt="Hero image" />
          </div>

        </div>
        
        <div className="av-scroll-cue" aria-hidden="true">
          <span>Scroll</span>
          <div className="av-scroll-line" />
        </div>
      </section>

      {/* Work / panes — the signature scroll moment */}
      <section className="av-panes" id="work">
        <h2 className="av-section-title"></h2>

        <div className="av-pane-stack">
          {PANES.map((pane, i) => {
            const depth = (i + 1) * 14;
            return (
              <article
                className="av-pane-card"
                key={i}
                style={{
                  transform: `translate3d(0, ${Math.max(
                    0,
                    paneShift * (PANES.length - i) - depth
                  )}px, 0)`,
                }}
              >
                <div className="av-pane-index">{pane.id}</div>
                <div className="av-image-placeholder av-image-placeholder--pane">
                  <img style={{width:"100%"}} src={pane.src} alt={pane.title}></img>
                </div>
                <h3>{setlang==="en"? pane.title_en:pane.title_fa}</h3>
                <p>{setlang==="en"? pane.note_en:pane.note_fa}</p>
              </article>
            );
          })}
        </div>
      </section>
      
      {/* Process */}
      <section className="av-process" id="process">
        {setlang==="en"?
        <div className="av-process-pane">
          <h2 className="av-section-title">From idea to spotlight</h2>
          <p>
            Every piece begins with an idea, the force of creativity, passion and material builds such scarecities that evok desires.
            Low in paradise, things look nice. 
            Take your last step with us and place your creations for demonstration and sales.
          </p>
        </div>
        :
        <div className="av-process-pane">
          <h2 className="av-section-title">از ایده تا نمایش</h2>
          <p>
            تجربه‌ای جدید از بازار دیجیتال.
            وارد یک بازار مدرن شو جایی که میتونی آثارتو برای نمایش با دیگران به اشتراک بگذاری و شرایط خرید و تماس رو مهیا کنی.
            راهی هوشمندانه‌تر برای خرید و فروش هر چیزی که علاقه شما رو بر می‌انگیزه
          </p>
        </div>
        }
        <div className="av-image-placeholder av-image-placeholder--logo">
          <span>
            <img
              className="av-hero-image av-theme-img av-theme-img--dark"
              src="/BZG_dark.png"
              alt="BZG"
            />
            <img
              className="av-hero-image av-theme-img av-theme-img--light"
              src="/BZG-light.png"
              alt="BZG"
            />
          </span>
        </div>
      </section>
    </div>
    </div>
  );
}